import { getFallbackStoreId, parseStoreId } from '@/utils/cart.util';

export function readCookie(name: string): string {
  if (typeof document === 'undefined') return '';
  const prefix = `${name}=`;
  const match = document.cookie
    .split('; ')
    .find((row) => row.startsWith(prefix));
  return match ? decodeURIComponent(match.slice(prefix.length)) : '';
}

export const sanitizeCookieValue = (val: string | null) => {
  if (!val || val === 'null') return null;

  try {
    return decodeURIComponent(val).replace(/"/g, '');
  } catch {
    return val.replace(/"/g, '');
  }
};

export const fetchDataFromCookies = () => {
  let id: string | null = null;
  let accessToken: string | null = null;
  let sid: string = '';
  let storeId: number = 5001;

  let rawId = readCookie('ajs_user_id');
  const token = readCookie('access_token');
  const sIdToken = readCookie('sid');
  const storeIdValue = readCookie('storeId');

  if (!rawId || rawId === 'null') {
    rawId = readCookie('ajs_anonymous_id');
  }
  if (!rawId || rawId === 'null') {
    rawId = 'default-segment';
  }

  id = rawId;
  accessToken = token;
  sid = sIdToken ?? '';
  storeId = parseStoreId(storeIdValue) ?? getFallbackStoreId();

  return {
    id,
    accessToken,
    sid,
    storeId,
  };
};
